// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "GuestLazyComponent" + "." + "2631a7a9f129a6fa1ae9" + ".js";
};